module.exports = __webpack_public_path__ + "img/settings.08bf3609.png";